import React, { Component } from "react";
import "./index.css";
import { connect } from "../../utils";
import { Box } from "rebass";
import find from "lodash.find";
import bg1 from "./bg/bg1.jpg";
import bg2 from "./bg/bg2.jpg";
import bg3 from "./bg/bg3.jpg";
import bg4 from "./bg/bg4.jpg";
import bg5 from "./bg/bg5.jpg";
import bg6 from "./bg/bg6.jpg";
import bg7 from "./bg/bg7.jpg";
import bg8 from "./bg/bg8.jpg";
import bg9 from "./bg/bg9.jpg";
import bg10 from "./bg/bg10.jpg";
import bg11 from "./bg/bg11.jpg";

const data = [
  { id: "0", bg: bg1 },
  { id: "1", bg: bg2 },
  { id: "2", bg: bg3 },
  { id: "3", bg: bg4 },
  { id: "4", bg: bg5 },
  { id: "5", bg: bg6 },
  { id: "6", bg: bg7 },
  { id: "7", bg: bg8 },
  { id: "8", bg: bg9 },
  { id: "9", bg: bg10 },
  { id: "10", bg: bg11 }
];

class Body extends Component {
  checkImage = id => {
    let image = "";
    let result = find(data, function(item) {
      return item.id === id;
    });
    if (result) {
      return result.bg;
    }

    return image;
  };
  render() {
    const { id, children, layoutState } = this.props;
    const { values } = layoutState.getItemJS(id).props;
    // const contentWidth = values.width.contentWidth + values.width.type;
    // "100%"; //values.width.contentWidth+values.width.type;
    const bg =
      values.backgroundImage.url !== ""
        ? {
            backgroundImage: `url(${this.checkImage(
              values.backgroundImage.url
            )})`,
            backgroundRepeat: "repeat"
          }
        : {};
    return (
      <Container
        style={{
          backgroundColor: values.backgroundColor
        }}
      >
        <div
          className="fullheight"
          style={{
            padding: values.padding,
            maxWidth: "100%",
            ...bg
          }}
        >
          {children}
        </div>
      </Container>
    );
  }
}

const Container = Box.extend`
  display: block;
  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export default connect("layoutState")(Body);



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Layout/Body.js